import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/pages/ProtectedRoute";
import ErrorBoundary from "@/components/ErrorBoundary";
import Landing from "@/pages/Landing";
import SignIn from "@/pages/SignIn";
import SignUp from "@/pages/SignUp";
import AuthCallback from "@/pages/AuthCallback";
import Companion from "@/pages/Companion";
import Journal from "@/pages/Journal";
import History from "@/pages/History";
import Memories from "@/pages/Memories";
import Shared from "@/pages/Shared";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import Reflection from "@/pages/Reflection";
import Referrals from "@/pages/Referrals";
import AdminFeedback from "@/pages/AdminFeedback";
import Settings from "@/pages/Settings";
import Board from "@/pages/Board";

function App() {
    return (
        <ErrorBoundary>
            <div className="App grain min-h-screen relative">
                <AuthProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/signin" element={<SignIn />} />
                            <Route path="/signup" element={<SignUp />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route path="/shared/:token" element={<Shared />} />
                            <Route path="/privacy" element={<Legal variant="privacy" />} />
                            <Route path="/terms" element={<Legal variant="terms" />} />
                            <Route path="/board" element={<Board />} />
                            <Route element={<ProtectedRoute />}>
                                <Route path="/companion" element={<Companion />} />
                                <Route path="/companion/:conversationId" element={<Companion />} />
                                <Route path="/journal" element={<Journal />} />
                                <Route path="/history" element={<History />} />
                                <Route path="/memories" element={<Memories />} />
                                <Route path="/reflection" element={<Reflection />} />
                                <Route path="/invite" element={<Referrals />} />
                                <Route path="/settings" element={<Settings />} />
                                <Route path="/admin/feedback" element={<AdminFeedback />} />
                            </Route>
                            <Route path="/404" element={<NotFound />} />
                            <Route path="*" element={<Navigate to="/404" replace />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                background: '#EFEBE1',
                                color: '#3A3532',
                                border: '1px solid #E5DFD3',
                                fontFamily: 'Manrope, sans-serif',
                            },
                        }}
                    />
                </AuthProvider>
            </div>
        </ErrorBoundary>
    );
}

export default App;
